import React, { useEffect, useState } from 'react';
import styles from './DriverPerformance.module.css';
import { BACKEND_URL } from '../config';

export default function DriverPerformance({ range }) {
  const [drivers, setDrivers] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchDrivers = (all = false) => {
    setLoading(true);
    const q = all ? `${BACKEND_URL}/api/report/drivers?range=${range}` : `${BACKEND_URL}/api/report/drivers?range=${range}&limit=10`;
    fetch(q)
      .then((res) => res.json())
      .then((data) => setDrivers(Array.isArray(data) ? data : []))
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchDrivers(showAll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [range, showAll]);

  return (
    <div className={styles.driverPerformanceContainer}>
      <div className={styles.header}>
        <h3 className={styles.title}>Driver Performance</h3>
        <button
          className={styles.button}
          onClick={() => setShowAll((s) => !s)}
        >
          {showAll ? 'Collapse' : 'Show all'}
        </button>
      </div>

      {loading ? (
        <p className={styles.loadingText}>Loading...</p>
      ) : (
        <div className={styles.tableContainer}>
          <table className={styles.table}>
            <thead>
              <tr className={styles.tableHead}>
                <th>Driver</th>
                <th>Branch</th>
                <th>Total Deliveries</th>
                <th>Avg Time</th>
              </tr>
            </thead>
            <tbody>
              {drivers.length === 0 ? (
                <tr>
                  <td colSpan="4" className={styles.noDataCell}>No data</td>
                </tr>
              ) : (
                drivers.map((d) => (
                  <tr key={d.driver_id} className={styles.tableRow}>
                    <td className={styles.driverName}>{d.driver_name}</td>
                    <td className={styles.tableData}>{d.branch_name || '-'}</td>
                    <td className={styles.tableData}>{d.total_deliveries}</td>
                    <td className={styles.tableData}>{d.avg_delivery_time || '-'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
